module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.f64b44de.jpeg";